import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { Toast } from 'angular2-toaster';
import { noop } from 'lodash';
import { Subject } from 'rxjs';
import { IIcon } from '../../../shared/components/icon/icon.interface';
import { IconSizesEnum } from '../../../shared/components/icon/icons-sizes.enum';
import { IToasterData } from '../../../toaster/toaster.data';
import { ToasterStore } from '../../../toaster/toaster.store';
import { filter, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-delete-entity-toast',
  templateUrl: './delete-entity-toast.component.html',
  styleUrls: ['./delete-entity-toast.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeleteEntityToastComponent implements OnInit, OnDestroy {
  private _destroyed: Subject<boolean> = new Subject<boolean>();

  toast: Toast = null;
  label: string;
  onUndo: Function;
  onDismiss: Function;
  closeIcon: IIcon;

  constructor(
    private _toasterStore: ToasterStore,
    private _changeDetectorRef: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.closeIcon = {
      name: 'close',
      size: IconSizesEnum.small,
    };

    this._toasterStore
      .getToasterData()
      .pipe(
        filter((data: IToasterData) =>
          this.toast && data ? data.toastId === this.toast.toastId : false
        ),
        takeUntil(this._destroyed)
      )
      .subscribe((data: IToasterData) => {
        this.label = data.label;
        this.onUndo = data.onPrimaryAction || noop;
        this.onDismiss = data.onDismiss || noop;

        this._changeDetectorRef.markForCheck();
      });
  }

  undoDeleteEntity() {
    this.onUndo && this.onUndo();
  }

  ngOnDestroy() {
    this.onDismiss && this.onDismiss();

    this._destroyed.next(true);
    this._destroyed.unsubscribe();
  }
}
